module.exports = __webpack_public_path__ + "static/dashboard-dcb808aa7aaa5b39ebdfc62fe92ec5c4.png";